export default {
  getLocale: state => {
    return state.locale
  },
  getLang: state => {
    return state.currentLanguage
  },
  getContainerClass: state => {
    return state.containerClass
  },
  getLayout (state) {
    return state.layout
  },
  getDashboardTitle (state) {
    return state.dashboardTitle
  },
  menuData (state) {
    return state.menuData
  },
  actionType (state) {
    return state.actionType
  },
  masterType (state) {
    return state.masterType
  },
  masterTypeName (state) {
    return state.masterTypeName
  },
  getOfficeId (state) {
    return state.officeId
  },
  getHType (state) {
    return state.hType
  },
  getCurrency (state) {
    return state.currency
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js